import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./Hero.css";

const Hero: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  return (
    <section className="hero-section">
      <div className="hero-inner">
        <div className="hero-text">
          <span className="hero-label">AI-Powered Dispute Resolution</span>
          <h1 className="hero-headline">
            Justice,<br />
            <em>delivered</em><br />
            in minutes.
          </h1>
          <p className="hero-subline">
            Impartial, AI-powered decisions for real-world questions — researched, evidence-weighed, and delivered in minutes.
          </p>
          <div className="hero-actions">
            <button
              className="hero-cta-primary"
              onClick={() => navigate("/rain")}
            >
              Request a Decision
            </button>
            {!isAuthenticated && (
              <button
                className="hero-cta-secondary"
                onClick={() => navigate("/signup")}
              >
                Get Started Free
              </button>
            )}
          </div>
        </div>

        <div className="hero-visual">
          <img
            src="/HEROS.png"
            alt="LEX AI Dispute Resolution"
            className="hero-image"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
